
<template><A :href="To"
       :class="CssClass"
       @click="OnLinkClick"
       target="_self">
        <slot />
    </A></template>

<script>
 
 
    export default {
        data() {
            return {
                To: null,
                Argument: null,
                labelText: "",
                m_Attribute: {
                    DataType: "text",
                    Nullable: false,
                    Options: []
                }
            }
        }
        ,
        props: ["to", "argument" , "value", "DataType", "Attribute"],


        computed: {

            CssClass: {

                get: function () {
                    let result = "";

                    if (this.Attribute != null && this.Attribute.CssClass != null) {
                        result = this.Attribute.CssClass;
                    }

                    return result;
                }
            },

            Nullable: function () {
                if (this.m_Attribute.Nullable == null) {
                    this.m_Attribute.Nullable = false;
                }

                return this.m_Attribute.Nullable + "";
            },

         

            Disabled: {

                get: function () {
                    let result = false;

                    if (this.m_Attribute.Enabled != null) {
                        result = !this.m_Attribute.Enabled;
                    }

                    return result;
                }
            }
        }
        ,

        methods: {


            OnLinkClick(e) {
                e.preventDefault();

                debugger;
                this.$util.GoBack();
            },

            OnValueChange(e) {
                this.$emit("input", e.target.value);
            },

            UpdateElementByAttribute() {
                let foundOption = false;
                let i;


                if (this.m_Attribute.DataType == "Date") {
                    this.labelText = Utility.GetDateText(this.value);
                }
                else if (this.m_Attribute.DataType == "DateTime") {
                    this.labelText = Utility.GetDateTimeText(this.value);
                }
                else {

                    for (i = 0; i < this.m_Attribute.Options.length; i++) {
                        if ((this.value + "") === this.m_Attribute.Options[i].Value) {
                            this.labelText = this.m_Attribute.Options[i].Text + "(" + this.m_Attribute.Options[i].Value + ")";
                            foundOption = true;
                            break;
                        }
                    }

                    if (!foundOption) {
                        this.labelText = this.value;
                    }
                }
            }
        },

        created() {

            this.labelText = this.value;

            this.To = this.to;
            this.Argument = this.argument;

            if (this.nullable == "false") {
                this.m_Attribute.Nullable = false;
            }
            else {
                this.m_Attribute.Nullable = true;
            }

            if (this.DataType != null) {
                this.m_Attribute.DataType = this.DataType;
            }

            if (this.Attribute != null) {
                Utility.SetNotNullAttributes(this.m_Attribute, this.Attribute);
            }


        },

        watch: {

            to: function (newVal, oldVal) {
                this.To = newVal;
            },

            argument: function (newVal, oldVal) {
                this.To = newVal;
            },

            value: function (newVal, oldVal) {
                this.labelText = newVal;
                this.UpdateElementByAttribute();
            },

            DataType: function (newVal, oldVal) {
                this.m_Attribute.DataType = newVal;
                this.UpdateElementByAttribute();
            },

            Attribute: function (newVal, oldVal) {

                Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
                this.UpdateElementByAttribute();
            },

            nullable: function (newVal, oldVal) {

            }
        }


    }
</script>

<style>
</style>
